"use strict";

export var FormSettingsConstants = {
  FORM_SETTINGS_INITIALIZE: 'FORM_SETTINGS_INITIALIZE',
  FORM_SETTINGS_UPDATE: 'FORM_SETTINGS_UPDATE'
};